import { render, staticRenderFns } from "./RefundInvoice.vue?vue&type=template&id=12a7fc24&scoped=true"
import script from "./RefundInvoice.vue?vue&type=script&lang=js"
export * from "./RefundInvoice.vue?vue&type=script&lang=js"
import style0 from "./RefundInvoice.vue?vue&type=style&index=0&id=12a7fc24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a7fc24",
  null
  
)

export default component.exports